import { render } from "./VitrineHeader.vue?vue&type=template&id=28a9e03c&scoped=true"
import script from "./VitrineHeader.vue?vue&type=script&lang=js"
export * from "./VitrineHeader.vue?vue&type=script&lang=js"

import "./VitrineHeader.vue?vue&type=style&index=0&id=28a9e03c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28a9e03c"]])

export default __exports__